import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button,
  alpha,
} from '@mui/material';
import PropTypes from 'prop-types';

const PopupRequest = ({ isDialogOpen, setIsDialogOpen, companyTheme, addonName }) => {
  const handleCloseDialog = () => {
    setIsDialogOpen(false);
  };

  return (
    <Dialog
      open={isDialogOpen}
      onClose={handleCloseDialog}
      maxWidth='sm'
      className='locked-accounts'
    >
      <DialogTitle sx={{ fontWeight: 'bold', fontSize: '18px',
          color: '#2e7d32' }}>
        Add-on request received!
      </DialogTitle>
      <DialogContent sx={{ color: '#000' }}>
              <Typography
        sx={{
          fontSize: '16px',
          fontWeight: 500,
          color: '#00000', // dark green for success
        }}
      >
        Your request for the <strong>"{addonName}"</strong> add-on has been submitted. <br />
        Our team will contact you at your registered email.
      </Typography>
      </DialogContent>
      <DialogActions>
        <Button
          variant='contained'
          onClick={()=>handleCloseDialog()}
          sx={{
            backgroundColor: companyTheme
              ? companyTheme.primary.main
              : '#2196f3',
            '&:hover': {
              backgroundColor: companyTheme
                ? alpha(companyTheme.primary.main, 0.8)
                : alpha('#2196f3', 0.8),
            },
          }}
        >
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PopupRequest;

PopupRequest.propTypes = {
  isDialogOpen: PropTypes.bool,
  setIsDialogOpen: PropTypes.bool,
  companyTheme: PropTypes.object,
  addonName: PropTypes.string,
};
